import React from 'react';
import { portal, Portal } from '../../../../Configs/general';
import { isPrintableAscii } from '../../../../Utils/Misc/String';
import * as yup from 'yup';

import _get from 'lodash/get';
import { fullName } from '../../../../Utils/Format/Names';
import { NAMES_REGEX } from '../../../../Utils/Misc/RegEx';
import BrebInfoFormGDC from './BrebInfoForm.GDC';

export const brebInfoSchema = yup.object({
  email: yup
    .string()
    .trim()
    .lowercase()
    .email('Debes ingresar un correo válido')
    .test(
      'is-ascii',
      'Este campo no puede contener tildes ni caracteres especiales',
      isPrintableAscii
    )
    .nullable()
    .required('Debes ingresar un correo'),
  firstName: yup
    .string()
    .trim()
    .max(150, 'Máximo 150 caracteres')
    .matches(NAMES_REGEX, 'No se permiten números ni caracteres especiales')
    .nullable()
    .required('Debes ingresar los nombres del pagador'),
  lastName: yup
    .string()
    .trim()
    .max(150, 'Máximo 150 caracteres')
    .matches(NAMES_REGEX, 'No se permiten números ni caracteres especiales')
    .nullable()
    .required('Debes ingresar los apellidos del pagador'),
  typeOfIdentification: yup
    .string()
    .trim()
    .nullable()
    .required('Debes seleccionar una opción válida'),
  identification: yup
    .string()
    .trim()
    .nullable()
    .required('Debes ingresar una identificación válida'),
  phone: yup
    .string()
    .trim()
    .length(10, 'Debe tener 10 dígitos')
    .nullable()
    .required('Debes ingresar un teléfono válido'),
  phoneCountryCode: yup
    .string()
    .trim()
    .max(3, 'Debe tener máximo 3 dígitos')
    .nullable()
    .required('Debes ingresar un prefijo válido'),
  typeOfPerson: yup
    .string()
    .trim()
    .nullable()
    .required('Debes seleccionar una opción válida')
});

export const getFormDefaultValuesBreb = currentUser => ({
  email: _get(currentUser, 'email') || '',
  payerFullName: currentUser
    ? `${fullName(currentUser, 'firstName', 'lastName')}`
    : '',
  firstName: _get(currentUser, 'firstName') || '',
  lastName: _get(currentUser, 'lastName') || '',
  typeOfIdentification: _get(currentUser, 'identificationType') || 'CC',
  identification: _get(currentUser, 'identification') || '',
  phone: _get(currentUser, 'phone') || '',
  phoneCountryCode: _get(currentUser, 'phoneCountryCode') || '57',
  typeOfPerson: 'N'
});

const BrebInfoForm = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <BrebInfoFormGDC {...props} />;
    default:
      return <></>;
  }
};

export default BrebInfoForm;
